// The four lists Today's Reminders chooses from, and the words that differ between their pages and editor.
// `field` is where the list lives on the compass: at its root for a list of its own, or on each category when
// `grouped`. `screen` is the page (Home's tile and + go there too); `arrows` marks habits' ↑ and ↓.
export const COMPASS_KINDS = {
  mindset: {
    screen: "mindset", field: "mindset", grouped: false, title: "Mindset",
    one: "mindset reminder", many: "mindset reminders",
    newTitle: "New mindset reminder", editTitle: "Edit mindset reminder", textLabel: "Mindset reminder",
    placeholder: "e.g. Starting always sounds worse than it is.",
    repeat: "You already have this mindset reminder.",
    intro: "Mindset reminders are short thoughts that help you get started.",
    empty: "You don't have any mindset reminders yet. A mindset reminder is a short thought that helps you get started, like \"Done is better than perfect.\"",
  },
  gratitude: {
    screen: "gratitude", field: "gratitude", grouped: false, title: "Gratitude",
    one: "gratitude reminder", many: "gratitude reminders",
    newTitle: "New gratitude reminder", editTitle: "Edit gratitude reminder", textLabel: "Gratitude reminder",
    placeholder: "e.g. My kids, who make me laugh every day",
    repeat: "You already have this gratitude reminder.",
    intro: "Gratitude reminders are the people and things you're thankful for. Seeing them can lift your mood when it's hard to get going.",
    empty: "You don't have any gratitude reminders yet. A gratitude reminder is something you're thankful for, like \"A warm home on a cold day.\"",
  },
  habits: {
    screen: "habits", field: "habits", grouped: true, arrows: true, title: "Habits",
    one: "habit", many: "habits",
    newTitle: "New habit", editTitle: "Edit habit", textLabel: "Habit",
    placeholder: "e.g. Walk for 20 minutes after dinner",
    repeat: "You already have this habit in this category.",
    intro: "Habits are things you want to do more of, or less of. ↑ is a habit you're building. ↓ is one you're cutting back.",
    empty: "You haven't added any habits yet. A habit is something you want to do more of, like walking after dinner, or less of, like snacking late at night.",
  },
  temptations: {
    screen: "temptations", field: "traps", grouped: true, title: "Temptations",
    one: "temptation", many: "temptations",
    newTitle: "New temptation", editTitle: "Edit temptation", textLabel: "Temptation",
    placeholder: "e.g. Scrolling my phone in bed",
    repeat: "You already have this temptation in this category.",
    intro: "Temptations are the things that pull you off track. Naming them makes them easier to notice in the moment.",
    empty: "You haven't added any temptations yet. A temptation is something that pulls you off track, like checking email first thing.",
  },
};

// "1 habit", "3 temptations"
export const compassCount = (kind, n) => `${n} ${n === 1 ? COMPASS_KINDS[kind].one : COMPASS_KINDS[kind].many}`;
